import React, { useEffect, useRef, useState } from "react";

const Select = ({ defaultValue, list, onChange, value, isFilter, className, isProfile, valueKey, nameKey, id }) => {
    const [selectedValue, setSelectedValue] = useState(value || defaultValue);
    const inputRef = useRef(null);
    useEffect(() => {
        if (value) {
            setSelectedValue(value);
        }
    });
    const handleCountryChange = (key, event) => {
        setSelectedValue(event.target.value || event);
        onChange(event.target.value || event);  // Pass selected value to parent
    };

    return (
        <>
            {isFilter ? (
                <div className="filter-selection">
                    <select id={id} className={className} value={selectedValue} ref={inputRef} onChange={(value) => handleCountryChange('countryCodes', value)}>
                        {
                            list?.map((item, index) => (
                                <option className="item-name" key={index} value={item.value || item.name}>
                                    {item.name}
                                </option>
                            ))
                        }
                    </select>
                </div>
            ) : (
                <>
                    {isProfile ? (
                        <div className="drop-down-selection">
                            <select
                                id={id}
                                className={`custom-select no-default-arrow ${className} ${selectedValue ? '' : 'default-value'}`}
                                value={selectedValue}
                                ref={inputRef}
                                onChange={(e) => handleCountryChange('countryCodes', e)}
                            >
                                {list?.length > 0 ? (
                                    <>
                                        <option className="custom-option" value="">
                                            Select {id ? id : ''}
                                        </option>
                                        {list.map((item, index) => (
                                            <option
                                                className="custom-option"
                                                key={index}
                                                value={item[valueKey || 'value']}
                                            >
                                                {item[nameKey || 'name']}
                                            </option>
                                        ))}
                                    </>
                                ) : (
                                    <option className="custom-option" value="">
                                        Select {id ? id : ''}
                                    </option>
                                )}
                            </select>
                        </div>

                        // <div className="drop-down-selection ">
                        //     <select id={id}
                        //         className={`custom-select no-default-arrow ${className}`}
                        //         value={selectedValue}
                        //         ref={inputRef}
                        //         onChange={(e) => handleCountryChange('countryCodes', e)}
                        //     >
                        //         {list?.length > 0 ? (
                        //             <>
                        //                 {list?.map((item, index) => (
                        //                     <>
                        //                         { index === 0 ? (
                        //                             <>
                        //                             <option className="custom-option" value={null || ''}>
                        //                                 Select {id ? id : ''}
                        //                             </option>
                        //                             </>
                        //                         )}
                        //                         <option
                        //                             className="custom-option"
                        //                             key={index}
                        //                             value={item[valueKey || 'value']}
                        //                         >
                        //                             {item[nameKey || 'name']}

                        //                         </option>
                        //                     </>
                        //                 ))}
                        //             </>
                        //         ) : (
                        //             <option className="custom-option" value={null || ''}>
                        //                 Select {id ? id : ''}
                        //             </option>
                        //         )}

                        //     </select>

                        // </div>
                    ) : (
                        <select id={id} value={selectedValue} ref={inputRef} onChange={(value) => handleCountryChange('countryCodes', value)}>
                            {list.map((item, index) => (
                                <option key={index} value={item.code}>
                                    {item.code}
                                </option>
                            ))}
                        </select>
                    )}
                </>
            )}
        </>
    );

};

export default Select;


// import React from "react";

// const Select = () => {
//     return (
//         <select value={selectedCountry} onChange={handleCountryChange}>
//             {countryCodes.map((country, index) => (
//                 <option key={index} value={country.code}>
//                     {country.code}
//                 </option>
//             ))}
//         </select>
//     );
// };

// export default Select;